export default __webpack_public_path__ + "static/media/ic-galleries.31b603f4.svg";